import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

export type DevelopedForItemIcon = 'search' | 'details' | 'simulate' | 'notifications';

export type DevelopedForItem = {
  title: string;
  description: string;
  icon: DevelopedForItemIcon;
};

@Component({
  selector: 'app-developed-for-template',
  imports: [RouterLink],
  templateUrl: './developed-for-template.component.html',
  styleUrl: './developed-for-template.component.css'
})
export class DevelopedForTemplateComponent {
  @Input() sectionTitle = '';
  @Input() sectionDescription = '';
  @Input() items: DevelopedForItem[] = [];
  @Input() ctaLabel = '';
  @Input() ctaRoute = '';
}
